import { FootNoteRef, PreparedStatement } from "./prepared-statement"


export interface blurbList{
    items: PreparedStatement[],
    totalItems: number
}

export interface blurbResponse{
    result: blurbList
    success: boolean
}

export interface newBlurbResponse{
    result: PreparedStatement,
    success: boolean
}

export interface removeResponse{
    success: boolean
}

export interface footnoteRefResponse{
    result: FootNoteRef
    success: boolean
}

export class blurbQueryParam{
    query: string;
    order: string;
    field: string;
    page: number;

    constructor(){
      this.query = '';
      this.order = '';
      this.field = '';
      this.page = 1;
    }
}
